export default __webpack_public_path__ + "static/media/modern-bg2.27c817d1.png";